import { Box } from "@mui/material";
import { FC } from "react";

import GameList from "./GameList";

const Home: FC = () => {
  return (
    <Box>
      <GameList />
    </Box>
  );
};

export default Home;
